import { type BREAKPOINTS } from '#src/constants/breakpoints';
import { useBreakpointContext } from './breakpoint-provider';

type BreakpointKey = keyof typeof BREAKPOINTS;

export function useBreakpoint<T extends BreakpointKey>(breakpoint: T) {
  const breakpoints = useBreakpointContext();
  const { isAbove, isBelow } = breakpoints[breakpoint];

  const capitalizedBreakpoint =
    breakpoint.charAt(0).toUpperCase() + breakpoint.slice(1);

  return {
    [`isAbove${capitalizedBreakpoint}`]: isAbove,
    [`isBelow${capitalizedBreakpoint}`]: isBelow,
  } as {
    [K in `isAbove${Capitalize<T>}`]: boolean;
  } & {
    [K in `isBelow${Capitalize<T>}`]: boolean;
  };
}
